(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.getElementById('IHNFreeCartDrawer');
  const labels = JSON.parse(document.getElementById('IHNFreeLabels')?.textContent || '"Er is iets misgegaan."');
  let lastFocus;
  let cartBusy = false;
  const money = cents => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const showError = (container, message) => {
    let alert = container.querySelector('[data-ihn-free-error]');
    if (!alert) { alert = document.createElement('p'); alert.className = 'ihn-free-error'; alert.dataset.ihnFreeError = ''; alert.setAttribute('role', 'alert'); container.prepend(alert); }
    alert.textContent = message || labels;
  };
  async function getCart() {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(labels);
    return response.json();
  }
  function countItems(cart) {
    return cart.items.reduce((sum, item) => sum + (item.properties?.['Lengte in meter'] || item.properties?.Besteleenheid?.includes('centimeter') ? 1 : item.quantity), 0);
  }
  function updateBadge(cart) {
    const count = countItems(cart);
    document.querySelectorAll('.ihn-cart-link').forEach(link => {
      link.setAttribute('aria-label', `Winkelwagen, ${count} artikelen`);
      let badge = link.querySelector('.ihn-cart-count');
      if (!badge && count) { badge = document.createElement('span'); badge.className = 'ihn-cart-count'; link.append(badge); }
      if (badge) { badge.textContent = count; badge.hidden = count === 0; }
    });
  }
  async function refreshCart() {
    const [cart, response] = await Promise.all([getCart(), fetch(root + '?section_id=ihn-free-cart-fragment', { credentials: 'same-origin' })]);
    if (!response.ok) throw new Error(labels);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const section = html.querySelector('.shopify-section');
    if (!section) throw new Error(labels);
    document.querySelectorAll('[data-ihn-free-cart-content],[data-ihn-free-cart-page]').forEach(container => { container.innerHTML = section.innerHTML; });
    updateBadge(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }
  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    if (!drawer.open) drawer.showModal();
  }
  function closeCart() {
    drawer?.close();
    lastFocus?.focus();
  }
  document.addEventListener('click', async event => {
    const filterClose = event.target.closest('[data-ihn-free-filter-close]');
    if (filterClose) { filterClose.closest('.ihn-free-filter').open = false; return; }
    const cartLink = event.target.closest('.js-drawer-open-cart');
    if (cartLink && drawer) {
      event.preventDefault(); openCart();
      try { await refreshCart(); } catch (error) { showError(drawer, error.message); }
      return;
    }
    if (event.target.closest('[data-ihn-free-cart-close]')) { closeCart(); return; }
    const remove = event.target.closest('[data-ihn-free-remove]');
    const adjust = event.target.closest('[data-ihn-free-qty]');
    if (!remove && !adjust) return;
    const row = (remove || adjust).closest('[data-key]');
    const input = row.querySelector('[data-ihn-free-cart-input]');
    const factor = Number(input.dataset.factor || 1);
    const next = remove ? 0 : Math.max(0, Math.round(Number(input.value) * factor + Number(adjust.dataset.ihnFreeQty) * factor));
    await changeCart(row, next);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.ihn-free-filter[open]').forEach(filter => { filter.open = false; filter.querySelector('summary').focus(); }); });
  drawer?.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCart();
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ihn-free-cart-input]')) {
      const factor = Number(event.target.dataset.factor || 1);
      changeCart(event.target.closest('[data-key]'), Math.max(0, Math.round(Number(event.target.value) * factor)));
    }
    
  });
  async function changeCart(row, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    row.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: row.dataset.key, quantity }) });
      if (!response.ok) { const error = await response.json(); throw new Error(error.description || labels); }
      await refreshCart();
    } catch (error) { showError(row, error.message); }
    finally { cartBusy = false; row.removeAttribute('aria-busy'); }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]') || form.closest('[data-ihn-showroom-booking]') || form.querySelector('.futureblink-booking-button') || form.closest('.meety-block-buttons')) return;
    event.preventDefault();
    const buttons = Array.from(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(button => button.disabled = true);
    form.setAttribute('aria-busy', 'true');
    form.querySelector('[data-ihn-free-error]')?.remove();
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || labels);
      await refreshCart(); openCart();
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
    } catch (error) { showError(form, error.message); }
    finally { form.removeAttribute('aria-busy'); buttons.forEach(button => button.disabled = false); }
  });
  const recommendationObserver = new IntersectionObserver(entries => {
    entries.filter(entry => entry.isIntersecting).forEach(async entry => {
      const element = entry.target; recommendationObserver.unobserve(element);
      try {
        const response = await fetch(element.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = doc.querySelector('[data-ihn-free-recommendations]');
        if (replacement) element.innerHTML = replacement.innerHTML;
      } catch (error) { element.hidden = true; }
    });
  }, { rootMargin: '300px' });
  document.querySelectorAll('[data-ihn-free-recommendations]').forEach(element => recommendationObserver.observe(element));
  const recent = document.querySelector('[data-ihn-free-recent]');
  function makeRecentCard(product) {
    const article = document.createElement('article'); article.className = 'grid-product';
    const anchor = document.createElement('a'); anchor.href = root + 'products/' + product.handle;
    const imageWrap = document.createElement('div'); imageWrap.className = 'grid-product__image-mask';
    if (product.featured_image) { const img = document.createElement('img'); img.src = product.featured_image; img.alt = product.title; img.loading = 'lazy'; imageWrap.append(img); }
    const body = document.createElement('div'); body.className = 'grid-product__meta';
    const title = document.createElement('div'); title.className = 'grid-product__title'; title.textContent = product.title;
    const price = document.createElement('div'); price.className = 'grid-product__price';
    price.textContent = product.tags?.includes('tapijt-per-centimeter') ? money(product.price * 100) : money(product.price);
    if (product.tags?.includes('prijs-op-aanvraag') || product.tags?.includes('offerte-op-aanvraag')) price.textContent = 'Prijs op aanvraag';
    body.append(title, price); anchor.append(imageWrap, body); article.append(anchor); return article;
  }
  async function loadRecent() {
    if (!recent) return;
    try {
      const previous = JSON.parse(localStorage.getItem('ihn-free-recent') || '[]');
      const current = recent.dataset.product;
      localStorage.setItem('ihn-free-recent', JSON.stringify([current, ...previous.filter(handle => handle !== current)].slice(0, 8)));
      const handles = previous.filter(handle => handle !== current).slice(0, 4);
      const products = await Promise.all(handles.map(async handle => { const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js'); return response.ok ? response.json() : null; }));
      const grid = recent.querySelector('[data-ihn-free-recent-grid]');
      products.filter(Boolean).forEach(product => grid.append(makeRecentCard(product)));
      recent.hidden = !grid.children.length;
    } catch (error) { recent.hidden = true; }
  }
  loadRecent();
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ihn-free-recommendations]').forEach(element => recommendationObserver.observe(element));
  });
})();
